/* @flow */
export const POOL = '#23BBCC';
export const POOL_RGB = '35, 187, 204';
export const BALLPOINT = '#1C2363';
export const MASCOT = '#0274DE';
export const GLOBE = '#8CC2F4';
export const PENNANT = '#6C40A3';
export const PENNANT_RGB = '108, 64, 163';

export const CHALKBOARD = '#000000';
export const GRAPHITE = '#656565';
export const WHITEOUT = '#FFFFFF';

export const CHART_ACTIVE_DOT_RADIUS = 8;
export const CHART_AREA_FILL_OPACITY = 0.9;
export const CHART_AXIS_FILL = GRAPHITE;
export const CHART_BAR_SIZE = 50;
export const CHART_GRID_COLOR = WHITEOUT;
export const CHART_HEIGHT = 300;
export const CHART_HEIGHT_SIMPLE = 180;
export const CHART_LEGEND_ALIGN = 'left';
export const CHART_LEGEND_ICON_SIZE = 12;
export const CHART_LINE_STROKE_WIDTH = 3;
export const CHART_MARGIN = { top: 0, right: 0, bottom: 0, left: 0 };
export const CHART_MARKER_TYPE = 'monotone';
export const CHART_MARKER_LEGEND_TYPE = 'circle';
export const CHART_REFERENCE_LINE_STROKE = PENNANT;
export const CHART_REFERENCE_LINE_STROKE_DASHARRAY = '10 8';
export const CHART_REFERENCE_LINE_STROKE_WIDTH = 2;
export const CHART_X_AXIS_PADDING = 50;
